import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Typography
} from "@mui/material";
import React from "react";

import {toTitleCase} from "../helpers/TextUtils";
import ContentTypeIcon from "./sessions/ContentTypeIcon";

export default function ContentTypeSelect({handleContentTypeChange, currentContentType, allContentTypes, disabled}) {

    return <>
        {
            (() => {
                return <FormControl fullWidth style={{minWidth: 120}}>
                    <InputLabel id="content-type-select-label">Content Type</InputLabel>
                    <Select
                      labelId='content-type-select-label'
                      id='content-type-select'
                      label='Content Type'
                      onChange={e => handleContentTypeChange(e.target.value)}
                      value={currentContentType}
                      disabled={disabled}
                      MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}>
                        {
                            allContentTypes.map((type) => (
                              <MenuItem key={type} value={type}>
                                  <Stack direction="row" alignItems="center" spacing={1}>
                                      <ContentTypeIcon contentType={type} iconSize={20}/>
                                      <Typography variant="body1" sx={{pl: 0.5}}>{toTitleCase(type)}</Typography>
                                  </Stack>
                              </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>;
            })()
        }
    </>;
}